import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-flexbox-grid';
import cn from 'classnames';
import style from './style.scss';

const propTypes = {
  title: PropTypes.string,
};

function Header({ title }) {
  return (
    <Row className={cn(style.header, 'header')} middle="xs">
      <Col xs={12} md={12} className="pull-left">
        <div>{title}</div>
      </Col>
    </Row>
  );
}

Header.propTypes = propTypes;
Header.defaultProps = {
  title: '',
};

export default Header;



// WEBPACK FOOTER //
// ./src/widget/header/index.js